// Copyright (c) 2016 Deere & Company

import './claims-settings.scss';
import React, {PropTypes} from 'react';
import {isClaimDaysToDisplayValid, isClaimStatusValid, isFormValid} from '../services/form-validation';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import ClaimSettingsModel from '@deere/cps-it.warranty-model-factory/lib/claims-settings';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import ErrorMessage from '../../../shared/components/error-message';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import Modal from '../../../product/shared/state/modal';
import SettingsHeader from '../../shared/components/settings-header';
import ToggleCheckboxesButton from '../../../shared/components/toggle-checkboxes-button';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getToggleLabel} from '../../shared/services/user-settings-helpers';
import {withRouter} from 'react-router';

let unListen;

function handleStatusChange(status, isSelected) {

    this.actions.updateClaimsStatus(status, isSelected);

}

function handleDaysToDisplayChange(value) {

    const updatedValue = value ?
        parseFloat(value) :
        null;

    this.actions.updateClaimsNumberOfDays(updatedValue);

}

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleToggleAll() {

    this.actions.toggleAllClaimStatus(this.userClaimSettings.status.allowedStatuses);

}

function handleConfirmSaveModal() {

    isFormValid(this.userClaimSettings) ?
        this.actions.confirmSaveModal(this.nextLocation) :
        this.actions.updateConfirmSaveModalVisibility(false);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

class ClaimsSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        const isStatusValid = isClaimStatusValid(this.props.userClaimSettings.status.selectedStatuses);
        const isDaysToDisplayValid = isClaimDaysToDisplayValid(this.props.userClaimSettings.numberOfDays);

        return (
            <section className='claims-settings'>
                <SettingsHeader
                    className='claims-settings-header'
                    isSaveDisabled={this.props.isSaved || !isFormValid(this.props.userClaimSettings)}
                    onSave={this.props::handleUserSettingsSave}
                    title='CLAIMS_OVERVIEW'
                />
                <section className='claims-settings-panel'>
                    <span className={`status ${isStatusValid ? '' : 'error'}`}>
                        <CheckboxListWithLabel
                            className='status-checkboxes'
                            initialState={createHashMap(this.props.userClaimSettings.status.selectedStatuses, 'key')}
                            isRequired={true}
                            label='STATUS'
                            list={addCollectionLabels(this.props.userClaimSettings.status.allowedStatuses, 'value')}
                            onChange={this.props::handleStatusChange}
                            uid='key'
                        />
                        <ErrorMessage
                            errorMessage='ONE_ITEM_MUST_BE_SELECTED'
                            isValid={isStatusValid}
                        />
                        <ToggleCheckboxesButton
                            label={getToggleLabel(this.props.userClaimSettings.status.selectedStatuses)}
                            listLength={this.props.userClaimSettings.status.allowedStatuses.length}
                            onClick={this.props::handleToggleAll}
                        />
                    </span>
                    <span className={`days-to-display ${isDaysToDisplayValid ? '' : 'error'}`}>
                        <section className='days-to-display-input'>
                            <FormattedMessage
                                id='DAYS_TO_DISPLAY'
                                tagName='h3'
                            />
                            <FormattedNumberInput
                                allowNegative={false}
                                isValidInput={value => value <= 1825}
                                onValueChange={this.props::handleDaysToDisplayChange}
                                value={this.props.userClaimSettings.numberOfDays}
                            />
                        </section>
                        <ErrorMessage
                            errorMessage='ENTER_A_NUMBER_FROM_1_TO_9999'
                            isValid={isDaysToDisplayValid}
                        />
                    </span>
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

ClaimsSettings.displayName = 'ClaimsSettings';
ClaimsSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userClaimSettings: PropTypes.instanceOf(ClaimSettingsModel).isRequired
};

export default withRouter(ClaimsSettings);



// WEBPACK FOOTER //
// ./src/user/claims-settings/components/claims-settings.js